/* Besøksskriptet for solgte varer (serie 22). Logikk: docs/varesystem/logikk/solgte-varer.md. Lastes på alle sider fra layout/theme.liquid.
   Avgjør om denne siden er første side i besøket («landing»), så solgt-boks.js bare viser rabatten til dem som landet på en solgt vare.
   - Uten lagring: siden er landing når henviseren ikke er vår egen side (ekstern eller tom). Intern navigasjon har alltid vår henviser.
   - Med uttrykkelig ja til preferanser (currentVisitorConsent().preferences === 'yes', ekomloven § 3-15): i tillegg en besøksmarkør i
     sessionStorage, så en senere side uten henviser (ny fane, streng henviserpolicy) aldri regnes som landing. Uten ja leses og skrives
     ingenting i nettleseren. «Tillatt i regionen» (preferencesProcessingAllowed) er ikke nok.
   Resultatet: window.ggLanding (true/false) og window.ggLandingAvklart, som blir true når samtykket er lest (eller API-et ikke kom på
   10 s). Hendelsen gg:landing sendes da, og når samtykket gis senere i besøket. */
(function () {
  'use strict';
  if (window.ggLandingKlar) return;
  window.ggLandingKlar = true;

  let intern = false;
  try {
    intern = !!document.referrer && new URL(document.referrer).host === location.host;
  } catch (e) {
    intern = false;
  }
  window.ggLanding = !intern;
  window.ggLandingAvklart = false;

  function api() {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    return cp && typeof cp.currentVisitorConsent === 'function' ? cp : null;
  }
  function uttrykkeligJa(cp) {
    try {
      return (cp.currentVisitorConsent() || {}).preferences === 'yes';
    } catch (e) {
      return false;
    }
  }
  function meld() {
    document.dispatchEvent(new CustomEvent('gg:landing', { detail: { landing: window.ggLanding } }));
  }

  let satt = false; // markøren er satt fra denne siden, så en ny samtykkehendelse ikke regner siden selv som «besøkt før»
  function medSamtykke(cp) {
    if (satt || !cp || !uttrykkeligJa(cp)) return;
    try {
      const fantes = sessionStorage.getItem('gg_besok') === '1';
      sessionStorage.setItem('gg_besok', '1');
      satt = true;
      if (fantes && window.ggLanding) {
        window.ggLanding = false;
        if (window.ggLandingAvklart) meld(); // samtykket kom etter avklaringen: boksen må skjule rabatten
      }
    } catch (e) { /* lagring sperret: henviseren alene avgjør */ }
  }
  function avklar() {
    if (window.ggLandingAvklart) return;
    medSamtykke(api());
    window.ggLandingAvklart = true;
    meld();
  }

  // Vent på samtykke-API-et (samtykkebanneret laster det); uten API på 10 s avgjør henviseren alene
  const start = Date.now();
  let bedt = false;
  (function vent() {
    if (api()) return avklar();
    if (!bedt && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      bedt = true;
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => { if (api()) avklar(); });
      } catch (e) { /* prøver igjen under */ }
    }
    if (Date.now() - start > 10000) return avklar();
    setTimeout(vent, 200);
  })();

  // Ja gitt senere i besøket: sett markøren da, så neste side ikke regnes som landing (denne siden er fortsatt landing)
  document.addEventListener('visitorConsentCollected', () => { medSamtykke(api()); });
})();
